import React, { useState } from "react";
import styles from "./style.module.css";
import Typography from "../Typography/Typography";

export interface Category {
    id: string;
    label: string;
}

interface CategorySelectorProps {
    categories: Category[];
    onSelect: (id: string) => void;
    defaultSelected?: string;
    className?: string;
}

export const CategorySelector: React.FC<CategorySelectorProps> = ({
    categories,
    onSelect,
    defaultSelected,
    className,
}) => {
    const [selected, setSelected] = useState<string | undefined>(defaultSelected);

    const handleSelect = (id: string) => {
        setSelected(id);
        onSelect(id);
    };

    return (
        <div className={`${styles.container} ${className ?? ""}`}>
            {categories.map((cat) => (
                <button
                    key={cat.id}
                    className={`${styles.categoryButton} ${selected === cat.id ? styles.active : ""}`}
                    onClick={() => handleSelect(cat.id)}
                >
                    <Typography
                    variant="heading6"
                    >
                        {cat.label}
                    </Typography>
                </button>
            ))}
        </div>
    );
};
